export function buildReturnReasons(product, comments) {
  if (comments?.reason1?.value) {
    return [
      product.bucket,
      comments?.reason1?.value,
      comments?.reason2?.value,
      comments?.reason3?.value,
    ].filter(Boolean).join('|');
  }
  return undefined;
}

export default function mapProductReturnDetail({ product, comments, seq }) {
  return {
    currency: product.currency,
    fromOrderItemToken: product.orderItemToken,
    imageId: product.imageId,
    itemId: product.itemId,
    itemPrice: product.itemPricePaidFmt.replace(/[^0-9.,]/g, ''),
    orderLineKey: product.orderLineKey,
    primeLineNo: product.primeLineKey,
    productId: product.productId,
    returnReasons: buildReturnReasons(product, comments),
    returnReasonCode: comments?.exchangeReason?.id?.toString(),
    returnReasonComments: comments?.exchangeComment || '',
    returnReasonDetailCode: comments?.exchangeSecondaryReason?.id?.toString() || null,
    salesTax: product.salesTaxFmt.replace(/[^0-9.,]/g, ''),
    sequence: seq.toString(),
    shippingTax: product.shippingTaxFmt.replace(/[^0-9.,]/g, ''),
    shortSku: product.partNumber,
    exchange: !!product.exchange,
    sizePrimary: product.exchange?.sizePrimary?.toString() || null,
    sizeSecondary: product.exchange?.sizeSecondary?.toString() || null,
    swatch: product.exchange?.swatch || null,
    seq: product.exchange?.seq?.toString() || null,
    newShortSku: product.exchange?.newShortSku || null,
  };
}
